import { MoreNavigationActionExtension } from "@geolib/geoappbase-client";
import { inject, Injectable } from "@angular/core";
import { StateService } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })

export default class UserProfileExtension extends MoreNavigationActionExtension {
    private readonly stateService = inject(StateService);

    public callback(): void {
        this.stateService.go("app.profile");
    }

    public isEnabled(): boolean {
        return true;
    }

    public get title(): string {
        return "HEADER.USER_PROFILE";
    }
}

